<script>




  // ?id=9921&dnApp=1&dnAppVersion=6.5.5
  // ?id=9921&dnApp=1&dnAppVersion=6.5.5&darkMode=1

import { onMount, afterUpdate } from 'svelte';
import { handleDarkModeSettings, darkModeClass, marginClass } from "../../scripts/darkMode";
import {baseUrl,getUrlVars} from "../../scripts/loadExternalData";  
import { burstPostRatio, getDisplayContext } from "../../scripts/helpers.js";

import Carousel from "./components/Carousel.svelte";

const state = {
  header: "From widget",
  introduction: "From widget",
  source: "From widget",
  arrowColor: "Ljus",
  showArrow: false,
  sideSlides: "1",
  autoPlay: false,
  sideSlideOpacity:"0.33",
  showPaggan:true,
  startSlide:1,
  appPadding:true,
  bradiusSmall:8,
  bradiusBig:12,
  backdropFilter:"blur(0px)",
  scaleStep: 0.2,
  transModifier:"{ 1: 70, 2: 50, 3: 67 }"
}

let slides = null;

let maxWidthSelected = "50%";
let maxWidth = "1280px";
let frameCss = "1px solid #fff";
let debug= false;
let borderRadius = 0;
let isBigScreen = false;

onMount(async () => {

    
    const artikel = parseInt(getUrlVars().artikel, 10);
    if (!isNaN(artikel)) state.startSlide = artikel;
    
    await fetchPatronData();
    await handleDarkModeSettings(state.darkModeSettings);

    let dspc = getDisplayContext?.() || {};
    isBigScreen = dspc.bigScreen || false;


    if(isBigScreen ){

        maxWidthSelected = state.imageFocusBig;
        maxWidth = state.maxwidth;
        frameCss = state.imageFrame;
        slides = state.bigscreensheet;
        borderRadius = state.bradiusBig;

    } else {
        
        
        maxWidthSelected = state.imageFocusSmall;
        maxWidth = state.maxwidth;
        frameCss = state.imageFrame;
        slides = state.smallscreensheet;
        borderRadius = state.bradiusSmall;

    }


   

    
   
    burstPostRatio();

    // console.log(state.bigscreensheet);

});


async function fetchPatronData() {
  const response = await fetch(`${baseUrl}/fields/${getUrlVars().id}`);
  const { fields, title } = await response.json();

  fields.forEach(({ key, value }) => {
    state[key] = value;
  });
  // console.log(state);
}





</script>


<main class={`main__content-wrapper ${$marginClass} ${state.appPadding ? '' : 'appPaddingOff'} ${$darkModeClass} ${debug ? 'quizdebug' : ''}`} class:BigScreen={isBigScreen}>

        {#if state.header}
        <div class={`standard-title`}>
            {state.header}
        </div>
        {/if}
        {#if state.introduction}
        <div class="standard-ingress">
            {@html state.introduction}
        </div>
        {/if}





 {#if slides && slides.length}
 <div class={`appwrapper aC_${state.arrowColor} ${state.showArrow ? 'showArrow' : ''} `} style={`max-width:${maxWidth}`}>
  <Carousel slides={slides} 
    maxWidthSelected={maxWidthSelected} 
    frameCss            = {frameCss} 
    sideSlides          = {state.sideSlides} 
    autoPlay            = {state.autoPlay} 
    sideSlideOpacity    = {state.sideSlideOpacity}
    showPaggan          = {state.showPaggan} 
    startSlide          = {state.startSlide}
    borderRadius        = {borderRadius} 
    backdropFilter      = {state.backdropFilter}
    scaleStep:          = {state.scaleStep}
    transModifier       = {state.transModifier}/>
 </div>
{:else}
  <p style="text-align:center; opacity:0.6;">Laddar bildspel …</p>
{/if}



       {#if state.source}
        <div class="standard-source">
            {@html state.source}
        </div>
        {/if}
</main>

<style global type="text/scss" lang="scss">


html, body {
  position: relative;
  height: unset;
  margin: 0;
  padding: 0;
  background-color: transparent;
}

body main.main__padded-width.appPaddingOff {

  padding-left: 0px;
  padding-right: 0px;
  box-sizing: border-box;

}
.appwrapper {
    position: relative;
    width: 100%;
    max-width: 1280px;
    padding:0;
    margin:0;
    margin-left: auto;
    margin-right: auto;

}

@media only screen and (min-width: 441px) {
  html, body {
    font-size: 6.81667px;
  }
}

@media only screen and (min-width: 520px) {
  html, body {
    font-size: 6.81667px;
  }
}


@media only screen and (min-width: 800px) {
  html, body {
    font-size: 8.81667px;
  }
}
</style>